module.exports = __webpack_public_path__ + "img/long_hair.eba3c046.jpg";